<button #button [disabled]="disabled" 
    class="≈border focus-visible:≈shadow-outline-sm md:focus-visible:≈shadow-outline focus:≈outline-primary-surface-selected 
        ≈rounded &*:active:hover:≈text-over-interactive ≈max-w-fit ≈font-medium ≈font-apple-system
        ≈transition-all ≈duration-75 ≈select-none &*:active:hover:≈fill-over-interactive disabled:≈border-disabled-border
        disabled:≈text-disabled-text disabled:≈cursor-auto disabled:≈pointer-events-none ≈text-sm lg:≈text-base 2xl:≈text-lg"
    [ngClass]="ngClass" (click)="click($event)" (keyup.enter)="click($event)">

    <content-container [ngClass]="{
        '≈opacity-0 ≈-z-10': loading
    }">
        <ng-content>
    
        </ng-content>

    </content-container>

    <ui-spinner *ngIf="loading" [mode]="UITextMode.default" class="≈absolute">

    </ui-spinner>
</button>